import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import confirmService from '../../services/confirm.service'
import metaApi, { MetaData } from '../../apis/meta.api'
import metaService from '../../services/meta.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../../components/TableHorizontal'
import Card from '../../components/Card'

interface MetasProps extends RouteComponentProps {}

interface MetasState {
  metas: TableHorizontalData<MetaData>[]
}

class Metas extends Component<MetasProps, MetasState> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Subscriber"), path: 'subscriber.name' },
    { heading: i18n("Addon"), path: 'addon.name' },
    { heading: i18n("Value"), path: 'value' },
    { heading: i18n("Attribute"), path: ['attribute.attributable.code', 'attribute.attributable.name'] },
    { heading: i18n("Updated at"), path: 'updatedAt', date: true },
    { heading: i18n("Actions") }
  ]

  constructor (props: MetasProps) {
    super(props)
    this.state = {
      metas: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = adminRoutes.metaEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the meta?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDeleteConfirm (id: number) {
    metaApi.delete(id, meta => {
      if (!meta) return
      const metas = metaService.delete(this.state.metas, id)
      this.setState({ metas })
    })
  }

  handleCreateClick () {
    this.props.history.push(adminRoutes.metaCreate)
  }

  listMetas () {
    metaApi.list(metas => {
      if (!metas) return
      const metaData = metaService.tableHorizontalData(metas)
      this.setState({ metas: metaData })
    })
  }

  componentDidMount () {
    this.listMetas()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Metas")}>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.tableHeaders}
              data={this.state.metas}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Metas)
